import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import MultiLegSelectionResultProcessor from '../../Components/Core/SelectionResults/MultiLegSelectionResultProcessor'
import MultiLegValidator from '../../Validation/MultiLegValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class MysteryConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'Mystery',
      name: 'Mystery',
      supportsFlexi: true,
      sortOptions: ['Number', 'Price', 'FixedPrice'],
      template: 'mystery-template',
      betSelectionTemplate: 'quad-checkbox-selection-template',
      multiBet: false,
      multiSelections: true,
      fieldCheckBoxCount: 0,
      checkBoxCount: 0,
      sameAsCheckBoxCount: 0,
      processor: new CheckboxSelectionProcessor(1),
      validator: new MultiLegValidator(4),
      selectionResultProcessor: new MultiLegSelectionResultProcessor(),
      legs: 1,
    })
  }
}
